import script from "./DocumentView.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentView.vue?vue&type=script&setup=true&lang=js"

import "./DocumentView.vue?vue&type=style&index=0&id=71de1a7c&lang=css"

const __exports__ = script;

export default __exports__